module.exports = __webpack_public_path__ + "img/nepal.2058263c.png";